module.exports = __webpack_public_path__ + "static/media/twitter-white.ff1f6b4a.svg";